import { render, staticRenderFns } from "./home-main.vue?vue&type=template&id=f127f1fe&scoped=true&lang=pug&"
import script from "./home-main.vue?vue&type=script&lang=js&"
export * from "./home-main.vue?vue&type=script&lang=js&"
import style0 from "./home-main.vue?vue&type=style&index=0&id=f127f1fe&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f127f1fe",
  null
  
)

export default component.exports